import { defineMessages } from 'react-intl'

const messages = defineMessages({
  notAvailableShort: {
    id: 'ReportTableRowValues.notAvailableShort',
    description: 'Texto para indicar N/D',
    defaultMessage: 'n.d.'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Charts/ReportTableRow/ReportTableRowValues/messages.js